module.exports = __webpack_public_path__ + "static/logo-084db041da666406cd445468bdb97c0f.svg";